var _defs, _rect, _g, _g2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06121C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2537"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#g3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 120 C240 120 200 150 200 186 a40 40 0 0 0 80 0 C280 150 240 120 240 120 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 300 C760 300 700 342 700 390 a60 60 0 0 0 120 0 C820 342 760 300 760 300 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240 160 C1240 160 1190 198 1190 240 a50 50 0 0 0 100 0 C1290 198 1240 160 1240 160 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#C81E2B",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520 620 C520 620 480 652 480 688 a40 40 0 0 0 80 0 C560 652 520 620 520 620 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 560 C1060 560 1024 590 1024 622 a36 36 0 0 0 72 0 C1096 590 1060 560 1060 560 Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 760,
    r: 220,
    fill: "#C81E2B",
    opacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero3);
export default __webpack_public_path__ + "static/media/hero3.91ba4177f29fd67101c2504e077d2a68.svg";
export { ForwardRef as ReactComponent };